<template>
  <div>
    <div>
      <div v-if="scaleEven">
        <div class="arrow-steps d-flex">
          <div
            v-for="(left, i) in scale / 2"
            :key="'arrow-left-' + i"
            class="arrow-steps__arrow arrow-steps__arrow--left"
            :class="getArrowClass('left', i)"
          ></div>

          <div
            v-for="(right, i) in scale / 2"
            :key="'arrow-right-' + i"
            class="arrow-steps__arrow arrow-steps__arrow--right"
            :class="getArrowClass('right', i)"
          ></div>
        </div>
      </div>
      <div v-else>
        <div class="arrow-steps d-flex">
          <div
            v-for="(left, i) in Math.floor(scale / 2)"
            :key="'arrow-left-' + i"
            class="arrow-steps__arrow arrow-steps__arrow--left"
            :class="getArrowClass('left', i)"
          ></div>
          <div class="arrow-steps__center arrow-steps__arrow-active arrow-steps__arrow"></div>
          <div
            v-for="(right, i) in Math.floor(scale / 2)"
            :key="'arrow-right-' + i"
            class="arrow-steps__arrow arrow-steps__arrow--right"
            :class="getArrowClass('right', i)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ArrowStepsCenter',
  props: {
    value: {
      type: Number,
    },
    scale: {
      type: Number,
    },
  },
  computed: {
    scaleEven() {
      return this.scale % 2 === 0;
    },
  },
  methods: {
    getArrowClass(side, i) {
      let classes = [];
      const numberOnSide = Math.floor(this.scale / 2);

      let index = side === 'left' ? i + 1 : i + Math.ceil(this.scale / 2) + 1;

      if (this.scaleEven) {
        if (side === 'left') {
          if (i === this.scale / 2 - 1) classes.push('clip-init--left');
          if (this.value <= numberOnSide) {
            if (this.value <= index) classes.push('arrow-steps__arrow-active');
          }
        } else {
          if (i === 0) classes.push('clip-init--right');
          if (this.value >= numberOnSide) {
            if (this.value >= index) classes.push('arrow-steps__arrow-active');
          }
        }
      } else {
        if (side === 'left') {
          if (i === numberOnSide - 1) classes.push('clip-init--left');
          if (this.value <= numberOnSide) {
            if (this.value <= index) classes.push('arrow-steps__arrow-active');
          }
        }

        if (side === 'right') {
          if (i === 0) classes.push('clip-init--right');
          if (this.value >= numberOnSide) {
            if (this.value >= index) classes.push('arrow-steps__arrow-active');
          }
        }
      }

      return classes;
    },
  },
};
</script>
<style lang="scss">
.arrow-steps__arrow {
  background: $base_grey-2;
  flex: 1;
  height: 0.7rem;
  border-radius: 0.1rem;
}

.arrow-steps__arrow-active {
  background: $bq-green;
}

.arrow-steps__center {
  clip-path: polygon(0 0, 100% 0, 100% 50%, 100% 100%, 0% 100%, 0% 50%);
  margin: 0 4px;
}

.arrow-steps__arrow--left {
  clip-path: polygon(5% 0, 100% 0, 95% 50%, 100% 100%, 5% 100%, 0% 50%);
}

.arrow-steps__arrow--right {
  clip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%, 5% 50%);
}

.clip-init--left {
  clip-path: polygon(5% 0, 100% 0, 100% 50%, 100% 100%, 5% 100%, 0% 50%);
}

.clip-init--right {
  clip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%, 0% 50%);
}
</style>
